'use client';
import { useRef } from 'react';

const useEnforceFocus = (initialValue = null)=>{
    const ref = useRef(initialValue);
    const enforceFocus = ()=>{
        var _ref_current_focus, _ref_current;
        return (_ref_current = ref.current) == null ? void 0 : (_ref_current_focus = _ref_current.focus) == null ? void 0 : _ref_current_focus.call(_ref_current);
    };
    return [
        ref,
        enforceFocus
    ];
};

export { useEnforceFocus };
//# sourceMappingURL=useEnforceFocus.js.map
